module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "preface-prof.-dr-klaus-herbers"
    }
  }, [_c('h1', [_vm._v("Preface Prof. Dr Klaus Herbers")]), _vm._v(" "), _c('p', [_vm._v("The "), _c('em', [_vm._v("Codex Calixtinus")]), _vm._v(" is the key document to understand the cult of St James and the pilgrimages to Santiago de Compostela. This compilation introduces very deeply into the spirituality of pilgrimage and devotion of the twelfth century. Although many things are still valid also for today, it is worth actualizing some of the messages.")]), _vm._v(" "), _c('p', [_vm._v("Berenika Seryczyńska has undertaken a very convincing way with ‘James’ Stories’ to assure this actualization, looking above all to the miracles of St-James, the second book of the "), _c('em', [_vm._v("Codex Calixtinus")]), _vm._v(" by individualizing the way to a journey by Michael (perhaps also a programmatic name). His journey to Santiago is a deliberately researched and enjoyably told tale. It brings together relevant hagiographical information, here recontextualized as the experiences of a modern man lost in the past experiencing these events and characters firsthand is a stroke of genius.")]), _vm._v(" "), _c('p', [_vm._v("Many of the old miracle tales are transformed and retold in a modern perspective, but we find an old and a new religious context at the same time. With narratives and dialogues, the reader gets a very close connection to the way of St-James and the miracles of hearing and seeing the events directly. This prose style is lucid, and your chapter titles")]), _vm._v(" "), _c('p', [_vm._v("clearly reinforce the established structure and pace well. Ultimately, I believe that ‘James Stories’ has the potential to proceed in its genre.")]), _vm._v(" "), _c('p', [_vm._v("Summing up, this book is an interesting and innovative way that helps understand the "), _c('em', [_vm._v("Codex Calixtinus")]), _vm._v(" and corresponds to the realities of the medieval pilgrimage, the way of St James, and its actual form. I only can congratulate on this result, and hopefully, the book will find much interest.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Prof. Dr Klaus Herbers")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Präsident Deutsche St Jakobus Gesellschaft")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em !important"
    }
  }, [_vm._v("Miembro del Comité de Expertos, Santiago de Compostela")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.96875in",
      "height": "0.96875in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0